<template>
  <div>
    <section class="photoList list10senNew_01 ">
      <div class="inner2">

        <div class="sectionTitle">
          Try &amp; Discover フォトコンテスト2019
        </div>

        <template v-for="n of 13">
        <div class="stage" v-if="winningWorks[idx(2019, n)] || winningWorks[idx(2019, n) + 1]" :key="n">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[idx(2019, n)], verticalM: !isHorizontal[idx(2019, n)] }" v-if="winningWorks[idx(2019, n)]&& winningWorks[idx(2019, n)].winningWorkIntroduction.winningWorkId >= 60000401 && winningWorks[idx(2019, n)].winningWorkIntroduction.winningWorkId <= 60000425">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2019, n)])"><img class="exhPhotoImg" :src="(winningWorks[idx(2019, n)].imageUrlS)" alt="" @load="(event) => loadHandler(event, idx(2019, n))" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[idx(2019, n)].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[idx(2019, n)].photographer}}</p>
              <ul v-if="isCommentaryExists(0)" class="photoCommentary">
                <li v-if="isCommentExists(0)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2019, n)], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(0)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2019, n)], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[idx(2019, n) + 1], verticalM: !isHorizontal[idx(2019, n) + 1] }" v-if="winningWorks[idx(2019, n) + 1]&& winningWorks[idx(2019, n) + 1].winningWorkIntroduction.winningWorkId >= 60000401 && winningWorks[idx(2019, n) + 1].winningWorkIntroduction.winningWorkId <= 60000425">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2019, n) + 1])"><img class="exhPhotoImg" :src="(winningWorks[idx(2019, n) + 1].imageUrlS)" alt="" @load="(event) => loadHandler(event, idx(2019, n) + 1)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[idx(2019, n) + 1].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[idx(2019, n) + 1].photographer}}</p>
              <ul v-if="isCommentaryExists(1)" class="photoCommentary">
                <li v-if="isCommentExists(1)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2019, n) + 1], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(1)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2019, n) + 1], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        </template>

        <div class="sectionTitle">
          Try &amp; Discover フォトコンテスト2020<br>～今こそ写真でつながろう。～
        </div>

        <template v-for="n of 14">
        <div class="stage" v-if="winningWorks[idx(2020, n)] || winningWorks[idx(2020, n) + 1]" :key="n">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[idx(2020, n)], verticalM: !isHorizontal[idx(2020, n)] }" v-if="winningWorks[idx(2020, n)]&& winningWorks[idx(2020, n)].winningWorkIntroduction.winningWorkId >= 60000426 && winningWorks[idx(2020, n)].winningWorkIntroduction.winningWorkId <= 60000452">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2020, n)])"><img class="exhPhotoImg" :src="(winningWorks[idx(2020, n)].imageUrlS)" alt="" @load="(event) => loadHandler(event, idx(2020, n))" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[idx(2020, n)].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[idx(2020, n)].photographer}}</p>
              <ul v-if="isCommentaryExists(0)" class="photoCommentary">
                <li v-if="isCommentExists(0)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2020, n)], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(0)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2020, n)], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[idx(2020, n) + 1], verticalM: !isHorizontal[idx(2020, n) + 1] }" v-if="winningWorks[idx(2020, n) + 1]&& winningWorks[idx(2020, n) + 1].winningWorkIntroduction.winningWorkId >= 60000426 && winningWorks[idx(2020, n) + 1].winningWorkIntroduction.winningWorkId <= 60000452">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2020, n) + 1])"><img class="exhPhotoImg" :src="(winningWorks[idx(2020, n) + 1].imageUrlS)" alt="" @load="(event) => loadHandler(event, idx(2020, n) + 1)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[idx(2020, n) + 1].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[idx(2020, n) + 1].photographer}}</p>
              <ul v-if="isCommentaryExists(1)" class="photoCommentary">
                <li v-if="isCommentExists(1)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2020, n) + 1], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(1)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2020, n) + 1], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        </template>

        <div class="sectionTitle">
          Try &amp; Discover フォトコンテスト2021<br>～1枚からしあわせをつくろう。～
        </div>

        <template v-for="n of 14">
        <div class="stage" v-if="winningWorks[idx(2021, n)] || winningWorks[idx(2021, n) + 1]" :key="n">
          <section class="exhPhotos photo01" :class="{ horizontalM: isHorizontal[idx(2021, n)], verticalM: !isHorizontal[idx(2021, n)] }" v-if="winningWorks[idx(2021, n)]&& winningWorks[idx(2021, n)].winningWorkIntroduction.winningWorkId >= 60000453 && winningWorks[idx(2021, n)].winningWorkIntroduction.winningWorkId <= 60000479">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2021, n)])"><img class="exhPhotoImg" :src="(winningWorks[idx(2021, n)].imageUrlS)" alt="" @load="(event) => loadHandler(event, idx(2021, n))" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[idx(2021, n)].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[idx(2021, n)].photographer}}</p>
              <ul v-if="isCommentaryExists(0)" class="photoCommentary">
                <li v-if="isCommentExists(0)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2021, n)], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(0)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2021, n)], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
          <section class="exhPhotos photo02" :class="{ horizontalM: isHorizontal[idx(2021, n) + 1], verticalM: !isHorizontal[idx(2021, n) + 1] }" v-if="winningWorks[idx(2021, n) + 1]&& winningWorks[idx(2021, n) + 1].winningWorkIntroduction.winningWorkId >= 60000453 && winningWorks[idx(2021, n) + 1].winningWorkIntroduction.winningWorkId <= 60000479">
            <a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2021, n) + 1])"><img class="exhPhotoImg" :src="(winningWorks[idx(2021, n) + 1].imageUrlS)" alt="" @load="(event) => loadHandler(event, idx(2021, n) + 1)" /></a>
            <div class="exhPhotoInfo">
              <h2 class="photoTitle">{{winningWorks[idx(2021, n) + 1].title}}</h2>
              <p class="photoTitleSub">{{winningWorks[idx(2021, n) + 1].photographer}}</p>
              <ul v-if="isCommentaryExists(1)" class="photoCommentary">
                <li v-if="isCommentExists(1)" class="expTxtBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2021, n) + 1], 'comment')"><img class="" src="/img2022/expTxt.png" srcset="/img2022/expTxt@2x.png 2x" alt="テキスト解説" /></a></li>
                <li v-if="isMovieExists(1)" class="expMovieBtn"><a href="javascript:void(0)" @click.stop="openImageViewer(winningWorks[idx(2021, n) + 1], 'movie')"><img class="" src="/img2022/expMovie.png" srcset="/img2022/expMovie@2x.png 2x" alt="動画解説" /></a></li>
              </ul>
            </div><!-- /exhPhotoInfo-->
          </section>
        </div><!-- /stage-->
        </template>

        <div class="note">
          ※＠～は応募者のInstagramアカウント名です。
        </div>

      </div><!-- /inner-->
    </section><!-- /photoList-->
  </div>
</template>

<script>

export default {
  components: {
  },
  props: [
    'winner',
    'openImageViewer'
  ],
  data () {
    return {
      winningWorks: [],
      isHorizontal: {}
    }
  },
  methods: {
    loadHandler (event, index) {
      // 縦位置横位置判定
      if (event.target.naturalWidth > event.target.naturalHeight + 20) {
        this.$set(this.isHorizontal, index, true)
      } else {
        this.$set(this.isHorizontal, index, false)
      }
    },
    idx(year, n) {
      let baseIndex = 0
      if (year == 2020) baseIndex = 25
      if (year == 2021) baseIndex = 52
      return (n - 1) * 2 + baseIndex
    },
    isCommentaryExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction && (
          this.winningWorks[index].winningWorkIntroduction.comment ||
          this.winningWorks[index].winningWorkIntroduction.youtubeUrl
        )
      )
    },
    isCommentExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.comment
      )
    },
    isMovieExists (index) {
      return (
        this.winningWorks[index].winningWorkIntroduction &&
        this.winningWorks[index].winningWorkIntroduction.youtubeUrl
      )
    },
    imageUrlS (work) {
      return work.imageFile.replace('_l.jpg', '_s.jpg')
    }
  },
  created () {
    this.winningWorks = this.winner.winningWorks
  }
}
</script>
<style scoped>
.sectionTitle {
  margin: 32px 0px 64px 0px;
  font-size: 2rem;
}
.photoTitleSub {
  word-break:break-all;
}
.note {
  margin: 32px 0px 48px 0px;
  font-size: 0.7rem;
}
@media screen and (max-width:640px){
  .sectionTitle {
    margin: 32px 0px 64px 0px;
    font-size: 1rem;
  }
}
</style>
